
import React, { useState, useEffect } from "react";
import axios from "axios";
import AWS, { Config } from "aws-sdk";
import { v4 as uuidv4 } from "uuid";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Paper, Container, Grid, Typography, FormGroup, Divider, } from "@mui/material";
import { Card, CardContent } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import { configure } from "../../config";
import ApiService from "./../../ApiService";
import "./Create_user.css";

import { json, useLocation } from "react-router-dom";

export const Create_user = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const locState = location.state;
  const generateTempPassword = (givenName) => {
    // Generate a random 4-digit number
    const randomNumber = Math.floor(1000 + Math.random() * 9000);
    // Concatenate the given name, "@" symbol, and the random number
    const password = `${givenName}@${randomNumber}`;
    return password;
  };


  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [email, setEmail] = useState("");
  const [Given_name, setGiven_name] = useState("");
  const [middle_name, setmiddle_name] = useState("");
  const [username, setusername] = useState("");
  const [last_name, setLast_name] = useState("");
  const [phone_number, setphone_number] = useState("");
  const [Company_Name, setCompany_Name] = useState("");
  const [data, setData] = useState([]);
  const [isAdminAccess, setIsAdminAccess] = useState(false);
  const [isDisabledAdminAccess, setIsDisabledAdminAccess] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [companyNames, setCompanyNames] = useState([]);
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [isCreateButtonDisabled, setCreateButtonDisabled] = useState(false);
  const [isUpdateButtonDisabled, setUpdateButtonDisabled] = useState(true);

  const [productAccess, setProductAccess] = useState({
    ddSEQ: false,
    Genesis: false,
    Sequoia: false,
  });

  const [formErrors, setFormErrors] = useState({
    email: "",
    Company_Name: "",
  });
  const config = {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
      'Content-Type': 'application/json',
    }
  };
  var idToken = JSON.parse(sessionStorage.getItem("accessToken"));

  useEffect(() => {
    if (locState && Array.isArray(locState) && locState.length > 0) {
      setCreateButtonDisabled(true);
      setUpdateButtonDisabled(false);
      const data = locState[0]; // Assuming the data is the first element of the array
      setGiven_name(data.given_name);
      setusername(data.Username);
      // setusername(data.Username);
      setLast_name(data.family_name);
      setEmail(data.email);
      setphone_number(data.phone_number);
      setSelectedCompanyName(data.nickname);
      setIsAdminAccess(data['custom:Admin_Access'] === "true");
      setProductAccess({
        ddSEQ: data['custom:ddSEQ'] === "true",
        Genesis: data['custom:Genesis'] === "true",
        Sequoia: data['custom:Sequoia'] === "true",
      });
    }
    fetchData();
  }, []);

  const datastutus = JSON.stringify({
    Status: "A",
  });

  const handleSelectChange = (e) => {
    let companyName = e.target.value.trim();
    setSelectedCompanyName(companyName)
    setIsDisabledAdminAccess(false);
    if(companyName !== "Bio-Rad" && companyName !== "BioRad" && companyName !== "Biorad" && companyName !== "BIORAD" && companyName !== "BIO-RAD")
    {
      setIsAdminAccess(false);
      setIsAdminAccess(false);
      setIsDisabledAdminAccess(true);
    }
  };

  const fetchData = async () => {
    try {
      config.headers.Authorization = "Bearer " + idToken.jwtToken;
      const response = await fetch(`${configure.backendUrl}/listcompany`, {
        method: 'POST',
        body: datastutus,
        headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
      });
      const responseCompany = await response.json();
      if (responseCompany && response.status === 200) {
        const responsedata = responseCompany;
        setCompanyNames(responsedata);
      } 
      else {
        navigate('/login');
      }
    } catch (error) {
      console.error("Error fetching company names:", error);
    }
  };

  const handleProductChange = (product) => {
    setProductAccess((prevState) => ({
      ...prevState,
      [product]: !prevState[product],
    }));
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleCloseSuccessAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };







  const handleAdminCreateUser = async () => {

    const tempPassword = generateTempPassword(Given_name, phone_number);

    if (
      Given_name.trim() === "" ||
      // phone_number.trim() === '' ||
      email.trim() === "" ||
      username.trim() === "" ||
      selectedCompanyName.trim() === "" // Add this check for Company Name
    ) {
      // Create a comma-separated list of empty fields
      const emptyFields = [];
      if (Given_name.trim() === "") emptyFields.push("Given Name");
      // if (phone_number.trim() === '') emptyFields.push('Phone Number');
      // if (Company_Name.trim() === '') emptyFields.push('Company Name');
      if (email.trim() === "") emptyFields.push("Email");
      if (username.trim() === "") emptyFields.push("username");
      if (selectedCompanyName.trim() === "") emptyFields.push("Company Name"); // Add Company Name to the list

      setAlertMessage(
        `Please Fill The Mandatory Fields: ${emptyFields.join(", ")}`
      );
      setOpenAlert(true);
      return;
    }

    if (Given_name.charAt(0) !== Given_name.charAt(0).toUpperCase()) {
      setAlertMessage("The first letter of Given Name should be uppercase.");
      setOpenAlert(true);
      return;
    }

    // Check for spaces in Given Name and Username
    if (Given_name.includes(" ") || username.includes(" ")) {
      setAlertMessage("Given Name and Username should not contain spaces.");
      setOpenAlert(true);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setAlertMessage("Please enter a valid email address.");
      setOpenAlert(true);
      return;
    }


    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,PUT,POST,OPTIONS,ANY",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Headers": "Origin, Content-Type, Accept, Authorization, X-Requested-With, privatekey",
        Authorization: "",
      },
    };


    const userDetail = JSON.stringify({
      givenname: Given_name,
      username: username, // You can set this value as needed
      //  family_name:last_name,
      company_name: selectedCompanyName,
      email: email,
      //  phone_number:phone_number,
      Admin_Access: isAdminAccess.toString(),
      ddSEQ: isAdminAccess ? "true" : productAccess.ddSEQ.toString(),
      Genesis: isAdminAccess ? "true" : productAccess.Genesis.toString(),
      Sequoia: isAdminAccess ? "true" : productAccess.Sequoia.toString(),

      tempPassword: tempPassword,
    });

    try {
      config.headers.Authorization = "Bearer " + idToken.jwtToken;
      const response = await fetch(`${configure.backendUrl}/createuser`, {
        method: 'POST',
        body: userDetail,
        headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
      });
      const responseUser = await response.text();


      if (responseUser && response.status === 200) {
        if (responseUser === "User created and invitation email sent successfully.") {
          var error4 = responseUser
          setSuccessMessage(error4);
          setOpenSuccessAlert(true);
          return;
        }
        else if (responseUser === "User with the same username already exists") {
          var error5 = responseUser;
          setAlertMessage(error5);
          setOpenAlert(true);
          return;
        }
        else if (responseUser === "User with the same email already exists") {
          var error7 = responseUser;
          console.log(error7);
          setAlertMessage(error7);
          setOpenAlert(true);
          return;
        }
      }
      else {
        navigate('/login');
      }
    } catch (error) {
      setAlertMessage("unexpected error"); // Email already exists          
    }
  };




  const handleUpdateUser = async () => {
    if (
      Given_name.trim() === "" ||
      email.trim() === "" ||
      username.trim() === "" ||
      selectedCompanyName.trim() === ""
    ) {
      const emptyFields = [];
      if (Given_name.trim() === "") emptyFields.push("Given Name");
      if (email.trim() === "") emptyFields.push("Email");
      if (username.trim() === "") emptyFields.push("Username");
      if (selectedCompanyName.trim() === "") emptyFields.push("Company Name");
      setAlertMessage(
        `Please Fill The Mandatory Fields: ${emptyFields.join(", ")}`
      );
      setOpenAlert(true);
      return;
    }
    if (Given_name.charAt(0) !== Given_name.charAt(0).toUpperCase()) {
      setAlertMessage("The first letter of Given Name should be uppercase.");
      setOpenAlert(true);
      return;
    }
    try {
      let updatedProductAccess = { ...productAccess };
      if (isAdminAccess) {
        const confirmation = window.confirm(
          "By giving Admin access, the user will have access to all the Products. Is it ok to proceed?"
        );
        if (!confirmation) {

          setIsAdminAccess(false);
          return;
        } else {

          updatedProductAccess = {
            ddSEQ: true,
            Genesis: true,
            Sequoia: true,
          };
        }
      }
      const updatedData = JSON.stringify({
        givenname: Given_name,
        username: username,
        family_name: last_name,
        company_name: selectedCompanyName,
        email: email,
        Admin_Access: isAdminAccess.toString(),
        ddSEQ: updatedProductAccess.ddSEQ.toString(),
        Genesis: updatedProductAccess.Genesis.toString(),
        Sequoia: updatedProductAccess.Sequoia.toString(),
      });
      config.headers.Authorization = "Bearer " + idToken.jwtToken;
      const response = await fetch(`${configure.backendUrl}/updateuser`, {
        method: 'POST',
        body: updatedData,
        headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
      });
      const responseUpdate = await response.json();
      if (responseUpdate && response.status === 200) {
        if (response.status === 200) {
          setSuccessMessage("User updated successfully");
          setOpenSuccessAlert(true);
        } else {
          navigate('/login');
          setAlertMessage("Failed to update user");
          setOpenAlert(true);
        }
      }
      else {
        navigate('/login');
      }

    } catch (error) {
      console.error("Error updating user:", error);
      setAlertMessage("An error occurred while updating the user");
      setOpenAlert(true);
    }
  };

  return (
    <div>


      <Grid
        sticky
        sx={{
          flexDirection: "column",
          marginLeft: 2,
          marginRight: 3,
          height: 540,
        }}
      >
        {/* <div style={{ "height": "70vh", "overflow-y": "auto" }}> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            marginLeft: 1,
            marginTop: 3,
          }}
        >
          <Typography fontWeight={500} fontSize={22} color="text.secondary" sx={{ marginTop: -2, marginLeft: -1 }}>
            Create User{" "}
          </Typography>
        </Box>

        <Box sx={{ marginTop: 0, marginRight: 1 }}>
          <Divider sx={{ bgcolor: "#bdbdbd", borderBottomWidth: 1 }} />
        </Box>

        <Grid container spacing={1} marginTop={1}>
          <Grid item xs={12} sm={4}>
            <Typography component="h6" fontSize={15} required>
              Given Name *
            </Typography>
            <TextField
              autoComplete="given-name"
              type="text"
              name="Given_name"
              value={Given_name}
              required
              fullWidth
              id="First Name"
              // label="Given_name"
              autoFocus
              size="small"
              className="form-control"
              onChange={(e) => setGiven_name(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography component="h6" fontSize={15}>
              Username *
            </Typography>
            <TextField
              autoComplete="given-name"
              type="text"
              name="Middle Name"
              value={username}
              //    placeholder="Middle Name"
              // required
              fullWidth
              id="Middle Name"
              //    label="Middle Name"
              // type="Sl"
              autoFocus
              size="small"
              className="form-control"
              onChange={(e) => setusername(e.target.value)}
              disabled={!!isCreateButtonDisabled}

            />
          </Grid>





          <Grid item xs={12} sm={4}>
            <Typography component="h6" fontSize={15}>
              E-Mail *
            </Typography>
            {/* {alertMessage && <p>{alertMessage}</p>} */}
            <TextField
              autoComplete="given-name"
              name="E-Mail"
              type="text"
              value={email}
              //   placeholder="Location"
              required
              fullWidth
              id="E-Mail"
              //   label="E-Mail"
              // type="Location"
              autoFocus
              size="small"
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
              disabled={!!isCreateButtonDisabled}
            />
            {/* {formErrors.email && <div className="error">{formErrors.email}</div>} */}
          </Grid>



          <Grid item xs={12} sm={9} >
            <Typography component="h6" fontSize={15}>
              Company Name *
            </Typography>
            <FormControl
              fullWidth
              size="small"
              error={!!formErrors.Company_Name}
            >
              {/* <InputLabel id="company-name-label">Select Company</InputLabel> */}
              <Select
                labelId="company-name-label"
                id="company-name-select"
                value={selectedCompanyName}
                placeholder="Location"
                required
                // label="Company Name *"
                onChange={handleSelectChange}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {companyNames.map((company) => (
                  <MenuItem
                    key={company.company_name}
                    value={company.company_name}
                  >
                    {company.company_name}
                  </MenuItem>
                ))}
              </Select>
              {/* {formErrors.Company_Name && <div className="error">{formErrors.Company_Name}</div>} */}
            </FormControl>
          </Grid>



          <Grid item xs={12} sm={3} >
            <Typography component="h6" fontSize={15}>
              Status
            </Typography>
            <TextField
              autoComplete="given-name"
              type="text"
              name="Company_Name"
              value={Company_Name}
              placeholder="New User "
              required
              fullWidth
              id="Company_Name"
              disabled
              //   label="Company_Name"
              // type="Infrastructure"
              autoFocus
              size="small"
              // sx={{ height:"50px"}}
              className="form-control"
            // onChange={(e) => setCompany_Name(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography
                variant="h6"
                fontSize={15}
                sx={{ marginRight: "16px", marginLeft: "5px" }}
              >
                Admin Access : 
               <br></br><div style={{ display: "flex",fontSize:'12px',fontWeight:"bold" , alignItems: "center", fontStyle: "italic" }}>{'(Only for BIO-RAD)'}</div> 
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAdminAccess}
                    onChange={(e) => setIsAdminAccess(e.target.checked)}
                    name="isAdminAccess"
                    disabled={isDisabledAdminAccess}
                  />
                  
                }

              />

            </div>
          </Grid>
        </Grid>

        <Divider
          sx={{
            bgcolor: "#bdbdbd",
            borderBottomWidth: 1,
            borderBottomRightRadius: 100,
            marginLeft: 1,
            marginTop: 2,
          }}
        />

        <Typography
          variant="h6"
          fontSize={15}
          style={{ margin: "30px 0", marginLeft: 2, marginTop: 20 }}
        >
          Product Access :
        </Typography>

        <FormGroup row style={{ marginLeft: 20 }}>
          {Object.keys(productAccess).map((product) => (
            <div
              key={product}
              style={{
                marginTop: 0,
                marginLeft: 120,
                marginRight: 5,
                fontSize: "14px",
              }}
            >
              <input
                className="custom-checkbox"
                style={{
                  width: "16px",
                  height: "16px",
                  marginRight: "5px",
                  marginTop: "5px",
                }}
                type="checkbox"
                id={product}
                checked={isAdminAccess ? "true" : productAccess[product]}
                onChange={() => handleProductChange(product)}

                disabled={isAdminAccess}

              />

              <label
                htmlFor={product}
                style={{ fontSize: "15px", marginBottom: "5px" }}
              >
                {product}
              </label>
            </div>
          ))}
        </FormGroup>

        <Button
          onClick={handleAdminCreateUser}
          // onClick={handleUpdateUser1}
          type="submit"
          halfWidth
          variant="contained"
          sx={{ mt: 4, mb: 1, marginLeft: 110, width: 50, marginTop: 1 }}
          color="success"

          disabled={isCreateButtonDisabled}

        >
          {" "}
          Submit{" "}
        </Button>

        <Button
          onClick={handleUpdateUser}
          type="submit"
          halfWidth
          variant="contained"
          sx={{ mt: 4, mb: 1, marginLeft: 1, width: 50, marginTop: 1 }}
          color="success"

          disabled={isUpdateButtonDisabled}

        >
          Update
        </Button>


        <Button
          onClick={() => navigate("/userdashboard")}
          type="submit"
          halfWidth
          variant="contained"
          sx={{ mt: 4, mb: 1, marginLeft: -26, width: 50, marginTop: 1 }}
          color="success"
          disabled={isUpdateButtonDisabled}

        >
          Back
        </Button>



        {/* </div> */}
      </Grid>


      <Snackbar
        open={openAlert}
        autoHideDuration={9000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseAlert}
          severity="error"
        >
          {alertMessage}
        </MuiAlert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={9000}
        onClose={handleCloseSuccessAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSuccessAlert}
          severity="success"
        >
          {successMessage}
        </MuiAlert>
      </Snackbar>



    </div>
  );
};

